"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSuffix = exports.isProductionHost = exports.getWindowHostName = exports.adpEnvironmentOptionList = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.string.ends-with.js");
/**
 * environmentSupport.js
 *
 * Holds support functions related to Dotcom environment.
 */

/**
 * ADP environment list
 */
var adpEnvironmentOptionList = {
  Staging: 'stg',
  Production: 'prd'
};

/**
 * Function to parse the Autodesk defined suffix from a given hostname (from the subdomain portion).
 * @param {string} subdomain
 */
exports.adpEnvironmentOptionList = adpEnvironmentOptionList;
var parseSuffix = function parseSuffix(subdomain) {
  var delimiter = '-';
  var parts = subdomain === null || subdomain === void 0 ? void 0 : subdomain.split(delimiter);
  var suffix = (parts === null || parts === void 0 ? void 0 : parts.length) > 1 ? parts[parts.length - 1] : undefined;
  return suffix ? "-".concat(suffix) : undefined;
};

/**
 * Function to return window host name.
 *
 * @returns string
 */
exports.parseSuffix = parseSuffix;
var getWindowHostName = function getWindowHostName() {
  if ((typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) !== 'object' || (0, _typeof2.default)(window.location) !== 'object' || window.location === null) {
    return '';
  }
  return window.location.hostname;
};

/**
 * Determines if we are on a prod site or not.
 * Prod subdomains & tlds are explicitally listed, use
 * 'stg' without a match.
 *
 * @param {*} currentHostname
 * @returns
 */
exports.getWindowHostName = getWindowHostName;
var isProductionHost = function isProductionHost(currentHostname) {
  var hostname = currentHostname || getWindowHostName();

  // If it's an Autodesk domain
  if (hostname.indexOf('autodesk.') > -1) {
    var subdomain = hostname.split('autodesk.')[0];
    var tld = hostname.split('autodesk.')[1];

    /**
     * These are all possible country TLDs
     * Older method - remove after move to new localized domains.
     */
    var oldProductionTlds = ['com', 'com.au', 'com.br', 'com.cn', 'com.hk', 'com.sg', 'com.tr', 'com.tw', 'co.kr', 'co.jp', 'co.nz', 'co.uk', 'co.za', 'ae', 'be', 'ca', 'ch', 'cn', 'cz', 'de', 'dk', 'es', 'eu', 'fi', 'fr', 'hu', 'in', 'it', 'mx', 'nl', 'no', 'pl', 'pt', 'se'];

    // Older method - remove after move to new localized domains.
    if (['asean.', 'latinoamerica.', 'app.etx-support.'].indexOf(subdomain) > -1 && tld === 'com' || ['www.', ''].indexOf(subdomain) > -1 && oldProductionTlds.indexOf(tld) > -1) {
      return true;
    }

    // Method for updated localized domains.
    if (['www.', ''].indexOf(subdomain) > -1 && (tld.endsWith('com') || tld.endsWith('com.cn'))) {
      return true;
    }
  }
  return false;
};
exports.isProductionHost = isProductionHost;